/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsshareeventempty3Inputs */

const en_groupsshareeventempty3 = /** @type {(inputs: Groupsshareeventempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile has no coming event right now.`)
};

const de_groupsshareeventempty3 = /** @type {(inputs: Groupsshareeventempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Profil hat gerade kein kommendes Event.`)
};

/**
* | output |
* | --- |
* | "This profile has no coming event right now." |
*
* @param {Groupsshareeventempty3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsshareeventempty3 = /** @type {((inputs?: Groupsshareeventempty3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsshareeventempty3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsshareeventempty3(inputs)
	return de_groupsshareeventempty3(inputs)
});
export { groupsshareeventempty3 as "groupsShareEventEmpty" }